export default __webpack_public_path__ + "static/media/linkedin.804b97dc.svg";